import { Component, OnInit } from '@angular/core';
import { StudentService } from '../_services/student.service';
import { OrgService } from '../_services/org.service';
import { Student } from './student';
import { Classroom } from '../dropdown-classroom/org.classroom';
import { Subscription } from 'rxjs';

@Component({
	selector: 'student-list',
	templateUrl: './student-list.component.html',
})
export class StudentListComponent implements OnInit {
	students: Array<Student>;
	classroom: Classroom;
	activeStudent: any;
	selectedClassroom: Subscription;
	query: any;
	href: any;

	constructor(private StudentService: StudentService, private OrgService: OrgService) {}

	ngOnInit(): void {
		(this.selectedClassroom = this.OrgService.selectedClassroom$.subscribe((classroom) => {
			classroom = JSON.parse(localStorage.getItem('selectedClassroom'))
				? JSON.parse(localStorage.getItem('selectedClassroom'))
				: classroom;
			this.StudentService.getStudents$(classroom.id).subscribe((data) => {
				this.activeStudent = JSON.parse(localStorage.getItem('selectedStudent'))
					? JSON.parse(localStorage.getItem('selectedStudent'))
					: data.students[0];
				this.StudentService.setStudent(this.activeStudent);
				this.students = data.students.sort((a, b) => a.fname.localeCompare(b.fname) || a.lname.localeCompare(b.lname));
				//this.students = data.students;
			});
		})),
			() => console.log('Observer got a complete notification');
	}

	setStudent(Student: Student) {
		localStorage.removeItem('activePhase');
		this.StudentService.setStudent(Student);
		this.activeStudent = Student;
	}
	ngOnDestroy() {
		this.selectedClassroom.unsubscribe();
	}
}
